var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "page page__wrapper wrapper" },
      [
        _c("FlashMessageContainer", { attrs: { messages: _vm.messages } }),
        _vm._v(" "),
        _c("LoadingIndicator"),
        _vm._v(" "),
        _c("Header"),
        _vm._v(" "),
        _c("div", { staticClass: "page__row", attrs: { id: "top" } }, [
          _c(
            "div",
            { staticClass: "page__sidebar" },
            [
              _c("Sidebar"),
              _vm._v(" "),
              _c("SidebarMobile"),
              _vm._v(" "),
              _c("ContactTeamModals")
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "page__main" }, [
            _c(
              "section",
              { staticClass: "page__container container-fluid" },
              [
                _c("MainColumn", {
                  staticClass: "page__content",
                  attrs: {
                    "component-name": _vm.componentName,
                    "sub-component-name": _vm.subComponentName
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("Footer")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }